import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10, 14);

  return (
    <footer className="relative bg-foreground-900 text-white mt-6 md:mt-10 mx-4 md:mx-6 rounded-t-3xl overflow-hidden">
      <div className="px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-xl font-semibold tracking-tight whitespace-nowrap cursor-pointer">
              Hoobuy Life
            </Link>
            <p className="text-white/50 text-sm mt-3 leading-relaxed max-w-xs">
              A melhor Hoobuy Spreadsheet em português. Links verificados e planilhas atualizadas para compradores em Portugal.
            </p>
          </div>

          {/* Category Columns */}
          <div className="lg:col-span-1">
            <h4 className="font-semibold text-sm mb-4">Categorias</h4>
            <ul className="space-y-2.5">
              {col1.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer"
                  >
                    {cat.namePt}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-1">
            <h4 className="font-semibold text-sm mb-4">&nbsp;</h4>
            <ul className="space-y-2.5">
              {col2.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer"
                  >
                    {cat.namePt}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-1">
            <h4 className="font-semibold text-sm mb-4">&nbsp;</h4>
            <ul className="space-y-2.5">
              {col3.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer"
                  >
                    {cat.namePt}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Social */}
          <div className="lg:col-span-1">
            <h4 className="font-semibold text-sm mb-4">Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/artigo/guia-completo-hoobuy-spreadsheet" className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  Guia Completo
                </Link>
              </li>
              <li>
                <Link to="/artigo/guia-de-compras-hoobuy" className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  Guia de Compras
                </Link>
              </li>
              <li>
                <Link to="/artigo/hoobuy-e-seguro" className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  Hoobuy é Seguro?
                </Link>
              </li>
              <li>
                <Link to="/artigo/hoobuy-vs-pandabuy" className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  Hoobuy vs Pandabuy
                </Link>
              </li>
              <li>
                <Link to="/" className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  Início
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                  hoobuy sheet
                </a>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-6">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white/70 transition-colors cursor-pointer" aria-label="External Link">
                <i className="ri-external-link-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 px-6 md:px-10 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            &copy; 2026 Hoobuy Life. Todos os direitos reservados.
          </p>
          <p className="text-white/30 text-xs">
            Especialistas em agentes chineses e marketplaces.
          </p>
        </div>
      </div>
    </footer>
  );
}